import { useEffect, useState, useCallback } from "react"
import { withStyles } from '@material-ui/core/styles'
import styles from './LearningCentreTabStyles'
import { httpRequest } from '../../../../ui-utils/api'
import {
  Typography, Button,
  MenuItem, Select, InputLabel, FormControl, Grid, Box,
  Snackbar,
  SnackbarContent,
  Paper,
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import dayjs from "dayjs"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import exportFromJSON from 'export-from-json'
import { IconButton } from "@material-ui/core"
import Modal from '@mui/material/Modal'
import { backendHosts, apiUrl } from '../../../../ui-utils/apiConfig'
import EditIcon from '@mui/icons-material/Edit'
import { format } from 'date-fns'
import CloseIcon from '@mui/icons-material/Close'

const style = {
  position: 'absolute !important',
  top: '50% !important',
  left: '50% !important',
  transform: 'translate(-50%, -50%) !important',
  width: '40% !important',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '15px !important',
  "@media only screen and (max-width: 1650px)": {
    width: '80% !important',
  },
};

const LearningCentre = ({ classes }) => {
  const [learningCentreData, setLearningCentreData] = useState([])
  const [Fdate, setFdate] = useState(null)
  const [Tdate, setTdate] = useState(null)
  const [academyUserDetail, setAcademyUserDetail] = useState({})
  const [status, setStatus] = useState('all')
  const [editModal, setEditModal] = useState(false)
  const [changeStatus, setChangeStatus] = useState("")
  const [error, setError] = useState("")
  const [fterror, setFTError] = useState("")
  const [snack, setSnack] = useState(false)

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  })

  const fontM = {
    fontFamily: "cardiuma-M !important"
  }

  const fontR = {
    fontFamily: "cardiuma-regular !important"
  }

  // DataGrid columns configuration
  const columns = [
    {
      field: 'created_on',
      headerName: 'Date',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      valueFormatter: (params) => format(new Date(params), 'yyyy-MM-dd HH:mm')
    },
    {
      field: 'name',
      headerName: 'Name',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
    },
    {
      field: 'email',
      headerName: 'Email',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
    },
    {
      field: 'phone',
      headerName: 'Phone no',
      type: 'number',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
    },
    {
      field: 'tdate',
      headerName: 'Training Date',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      valueFormatter: (params) => format(new Date(params), 'dd-MM-yyyy'),
    },
    {
      field: 'lang',
      headerName: 'Language',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
    },
    {
      field: 'slot',
      headerName: 'Slot',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
    },
    {
      field: 'coursename',
      headerName: 'Plan',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'Status',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
    },
    {
      field: 'actions',
      headerName: 'Action',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      renderCell: (params) => (
        <IconButton onClick={() => handleEditModal(params.row)}>
          <EditIcon />
        </IconButton>
      ),
    },
  ]

  // Fetch data useEffect
  useEffect(() => {
    fetchLearningCentreData({})
  }, [])

  const fetchLearningCentreData = async (payload) => {
    try {
      const response = await httpRequest({
        endPoint: `${backendHosts.ADMIN}${apiUrl.learningCentre}`,
        method: "post",
        instance: "instanceOne",
        requestBody: payload
      })
      if (response.status === 200) {
        setLearningCentreData(response.data)
      } else {
        console.log('Error in LearningCentre List API', response.data)
      }
    } catch (error) {
      console.log('Error in LearningCentre List API', error)
    }
  }

  const handleFDate = useCallback((newValue) => {
    setFdate(dayjs(newValue).format('YYYY-MM-DD'))
  }, [])

  const handleTDate = useCallback((newValue) => {
    setTdate(dayjs(newValue).format('YYYY-MM-DD'))
  }, [])

  const handleFormSubmit = async (e) => {
    e.preventDefault()
    if (Fdate === null || Tdate === null) {
      setFTError("Both From Date and To Date required *")
      return
    }
    const formData = { fdate: Fdate, tdate: Tdate }
    await fetchLearningCentreData(formData)
    setFTError("")
    setStatus("all")
    setPaginationModel({
      pageSize: 10,
      page: 0,
    })
  }

  const handleStatusChange = (currentStatus) => {
    setChangeStatus(currentStatus)
  }

  const handleSaveStatusChange = async (id) => {
    try {
      if (changeStatus.length === 0) {
        setError("Please select a status to save.")
        return
      }

      const payload = { id, status: changeStatus }
      const response = await httpRequest({
        endPoint: `${backendHosts.ADMIN}${apiUrl.learningCentreUpdate}`,
        method: "put",
        instance: "instanceOne",
        requestBody: payload
      })

      if (response.status === 200) {
        setLearningCentreData((prevRows) =>
          prevRows.map((row) =>
            row.id === id ? { ...row, status: changeStatus } : row
          )
        )
        handleClose()
        setSnack(true)
      }
    } catch (error) {
      console.log('Error in LearningCentre status update', error)
    }
  }

  const handleStatusChangeDropDown = (e) => {
    setStatus(e.target.value)
  }

  const handleEditModal = (row) => {
    setEditModal(true)
    setAcademyUserDetail(row)
  }

  const handleClose = () => {
    setEditModal(false)
    setAcademyUserDetail({})
    setChangeStatus("")
    setError("")
  }

  const handleReset = async () => {
    await fetchLearningCentreData({})
    setFdate(null)
    setTdate(null)
    setStatus("all")
    setFTError("")
    setPaginationModel({
      pageSize: 10,
      page: 0,
    })
  }

  const handleDownloadCsv = () => {
    const header = ["Date", "Name", "Email", "Phone no", "Traning date", "Language", "Slot", "Plan", "Status"]
    const data = filteredData.map(item => ({
      [header[0]]: dayjs(item.created_on).format('YYYY-MM-DD HH:mm'),
      [header[1]]: item.name,
      [header[2]]: item.email,
      [header[3]]: item.phone,
      [header[4]]: dayjs(item.tdate).format('DD-MM-YYYY'),
      [header[5]]: item.lang,
      [header[6]]: item.slot,
      [header[7]]: item.coursename,
      [header[8]]: item.status,
    }))

    exportFromJSON({
      data,
      fileName: 'Learning_Centre',
      exportType: exportFromJSON.types.csv
    })
  }

  const filteredData = status === "all"
    ? learningCentreData
    : learningCentreData.filter((item) => item.status === status)

  return (
    <div style={{ flex: '82%', marginLeft: '2%' }}>
      <Typography className={classes.dashboardText2} style={{ color: "#FFFFFF", marginTop: "6.5%", marginBottom: "2%" }}>
        Learning Centre
      </Typography>

      <div style={{ margin: '1% 1% 1% 0%' }}>
        <form className={classes.lcFormDateField} onSubmit={handleFormSubmit}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <span className={classes.datePickerWrapper}>
              <DatePicker
                label="From"
                format="DD-MM-YYYY"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                InputProps={{ className: classes.input }}
                className={classes.datePicker}
                value={Fdate}
                onChange={(newValue) => { handleFDate(newValue) }}

              />
            </span><br></br>

            <span
              className={classes.datePickerWrapper}
            >
              <DatePicker
                label="To"
                format="DD-MM-YYYY"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                InputProps={{ className: classes.input }}
                className={classes.datePicker}
                value={Tdate}
                onChange={(newValue) => { handleTDate(newValue) }}
              />
            </span>

          </LocalizationProvider>

          <Button type="submit" style={{
            width: '100px',
            height: '34px',
            margin: '4px 0 1px 12px',
            color: '#fff',
            backgroundColor: '#F44748',
            fontFamily: 'cardiuma-regular',
            fontSize: '11px',
            fontStyle: 'normal',
            marginRight: 2
          }}>Submit</Button>

          <Button onClick={handleReset} style={{
            width: '100px',
            height: '34px',
            margin: '4px 0 1px 12px',
            color: '#fff',
            backgroundColor: '#F44748',
            fontFamily: 'cardiuma-regular',
            fontSize: '11px',
            fontStyle: 'normal',
            marginRight: 10
          }}>Reset</Button>

          <Button
            style={{
              color: "#F3D45E",
              textDecoration: "underline",
              fontFamily: 'cardiuma-regular',
              fontSize: '13px',
              fontStyle: 'normal',
              fontWeight: 'bold',
            }}
            onClick={handleDownloadCsv}
          >
            Download CSV
          </Button>
          <Grid style={{ marginLeft: "70px", borderRadius: "5px" }} >
            <FormControl size="small" style={{ width: "100%" }}>
              <InputLabel className={classes.inputColor} id="demo-select-small-label">
                Status
              </InputLabel>
              <Select
                className={classes.select}
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={status}
                label="Select"
                onChange={(newValue) => { handleStatusChangeDropDown(newValue) }}
                displayEmpty
                MenuProps={{
                  PaperProps: {
                    style: {
                      top: '50px', // Control where dropdown will appear
                    },
                  },
                }}
                sx={{
                  height: '40px',
                  ".css-hfutr2-MuiSvgIcon-root-MuiSelect-icon": {
                    color: "white !important"
                  }
                }}
              >
                <MenuItem className={classes.intSelText} value="all">
                  All
                </MenuItem>
                <MenuItem className={classes.intSelText} value="new">
                  New
                </MenuItem>
                <MenuItem className={classes.intSelText} value="scheduled">
                  Scheduled
                </MenuItem>

              </Select>
            </FormControl>
          </Grid>
        </form>
      </div>
      {fterror && <Typography color="error" mb={1} ml={2}>{fterror}</Typography>}

      {/* DataGrid */}
      <Paper className={classes.horizantalTablayout} sx={{ height: '80vh' }}>
        <DataGrid
          rows={filteredData}
          columns={columns}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[10, 25, 50]}
          className={classes.customDataGrid}
          sx={{
            '--DataGrid-containerBackground': '#131E2E',
            '--DataGrid-rowBorderColor': '#000',
            'border': 0,
            width: '100% !important',
          }}
          pagination
          getRowId={(row) => row.id || row.email}
        />
      </Paper>

      <Modal open={editModal} onClose={handleClose} aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        academyUserDetail={academyUserDetail}>

        <Box sx={style}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'left',
              justifyContent: 'space-between', // Space between Typography and Button
              textAlign: 'left',
              width: '100%', // Ensures proper alignment within the container
            }}
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{
                fontFamily: 'cardiuma-M',
                fontWeight: 'bold',
                margin: '0 auto', // Keeps text in the center
              }}
            >
              Academy User Details
            </Typography>

            <Button onClick={handleClose} sx={{ minWidth: 'unset', padding: '0' }}>
              <CloseIcon style={{ color: 'red' }} />
            </Button>
          </Box>

          {/* Content section */}
          <Grid container sx={{ paddingTop: '20px !important' }}>
            <Grid item lg={4} sx={{ paddingLeft: '90px !important', height: 'auto !important' }}>
              <Typography mb={3} sx={{ paddingRight: '20px !important', fontFamily: 'cardiuma-M' }}>
                Date:
              </Typography>
              <Typography mb={3} sx={fontM}>Name:</Typography>
              <Typography mb={3} sx={fontM}>Email:</Typography>
              <Typography mb={3} sx={fontM}>Phone no:</Typography>
              <Typography mb={3} sx={fontM}>Training Date:</Typography>
              <Typography mb={3} sx={fontM}>Language:</Typography>
              <Typography mb={3} sx={fontM}>Slot:</Typography>
              <Typography mb={3} sx={fontM}>Plan:</Typography>
              <Typography mb={5} sx={fontM}>Status:</Typography>
              <Typography mb={3} sx={fontM}>Change Status:</Typography>
            </Grid>
            <Grid item lg={8}>
              <Typography sx={fontR} mb={3}>
                {dayjs(academyUserDetail.created_on).format('YYYY-MM-DD HH:mm')}
              </Typography>
              <Typography sx={fontR} mb={3}>{academyUserDetail.name}</Typography>
              <Typography sx={fontR} mb={3}>{academyUserDetail.email}</Typography>
              <Typography sx={fontR} mb={3}>{academyUserDetail.phone}</Typography>
              <Typography sx={fontR} mb={3}>
                {dayjs(academyUserDetail.tdate).format('DD-MM-YYYY')}
              </Typography>
              <Typography sx={fontR} mb={3}>{academyUserDetail.lang}</Typography>
              <Typography sx={fontR} mb={3}>{academyUserDetail.slot}</Typography>
              <Typography sx={fontR} mb={3}>{academyUserDetail.coursename}</Typography>
              <Typography sx={fontR} mb={3}>{academyUserDetail.status}</Typography>
              <Typography sx={fontR} mb={3}>
                <Select
                  value={changeStatus} // Bind to the state
                  onChange={(e) => handleStatusChange(e.target.value)} // Update the state on change
                  displayEmpty
                  // fullWidth
                  variant="outlined"
                >
                  <MenuItem value="">Change Status</MenuItem>
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="scheduled">Scheduled</MenuItem>
                </Select>

                <Button onClick={() => handleSaveStatusChange(academyUserDetail.id)} style={{
                  width: '100px',
                  height: '34px',
                  margin: '4px 0 1px 12px',
                  color: '#fff',
                  backgroundColor: '#F44748',
                  fontFamily: 'cardiuma-regular',
                  fontSize: '11px',
                  fontStyle: 'normal'
                }}>Save</Button>

                {error && <Typography color="error" mt={1}>{error}</Typography>}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <Snackbar
        open={snack}
        autoHideDuration={2000}
        onClose={() => setSnack(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <SnackbarContent
          sx={{
            backgroundColor: '#ffffff !important',
            color: 'black !important',
            borderLeft: "7px solid #8db600 !important",
            borderRadius: '3px !important',
            fontFamily: 'cardiuma-regular !important',
            fontSize: '12px !important'
          }}
          message={"updated successfully"}
        />
      </Snackbar>
    </div>
  )
}

export default withStyles(styles)(LearningCentre)